// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"e2116640","453":"de50740d","558":"cb912819","742":"382fe6c2"}[chunkId] + ".chunk.js";
};